import { Component, Vue } from 'vue-property-decorator';

/**
 * 列表页面
 */
@Component({ name: 'ListPage' })
export default class extends Vue {
}
